export const DISCUSSION_FETCH_TOPIC_DISTRIBUTION = 'DISCUSSION_FETCH_TOPIC_DISTRIBUTION';
export const DISCUSSION_FETCH_TOPIC_DISTRIBUTION_SUCCESS = 'DISCUSSION_FETCH_TOPIC_DISTRIBUTION_SUCCESS';
export const DISCUSSION_FETCH_TOPIC_DISTRIBUTION_FAIL = 'DISCUSSION_FETCH_TOPIC_DISTRIBUTION_FAIL';
